<template>
    <div class="members">
        <List v-if="client_id" :DB="list" :client_id="client_id" @emit="emit"/>
        <component v-if="component" :is="component" :item="item" @emit="emit" />
    </div>
</template>

<script>

import { mapMutations, mapActions } from 'vuex'
import List from '../components/List.vue'
import { format } from 'date-fns';
import prettyPhone from '../utils/prettyPhone.js'
import WebSoc from '../utils/WebSoc.js';
import CustomerStats from '../components/CustomerStats.vue';
import Stamps from '../components/Stamps.vue';
import EditMember from '../components/editMember.vue';
import Alert from '../utils/Alert.js'

export default {
    name: 'Messages',
    components: {
        List,
        Stamps,
        EditMember,
        CustomerStats
    },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    created () {
        this.list.filter.client_id = this.client_id;       
    },
    data () {
        return {
            component: '',
            item: false,
            list: { 
                t: 'messages-list',
                DB: 'messages',
                dbClient_id: '',
                storeDB: true,
                title: 'Messages',
                fields: [
                    { title: 'Date', class: 'td-ulb', field: 'created', width: 180, map: item => format(item.created,'dd/MM/yy HH:mm'), order: 'asc', type: 'date', format: 'dd/MM/yy HH:mm' },
                    { title: 'Responded', field: 'responded', width: 180, map: item => item.responded > 0 && format(item.responded,'dd/MM/yy HH:mm') || 'WAITING' },
                    { title: 'Staff', field: 'staffName', width: 200 },
                    { title: 'Member', field: 'name', width: 200 },
                    { title: 'Message', field: 'message', width: 400 },
                    
                ],
                filter: {},
                project: { customer_id: 1 },
                onItems ( items ) {
                    items.forEach(item => item.responded = item.responded || false);
                }
            } 
        }
    },
    methods: {
        newMessage () {
            console.log('new Message ?');
        },
        deleteMessage ( message ) {
            Alert.yesno('Delete message ?',yes => {
                if ( !yes ) return;
                WebSoc.SEND('delete',{ DB: 'messages', _id: message._id },resp => {
                    console.log('deleted resp',resp);
                })
            })
        },
        'messages-list' ({ action, field, item, value, e }) {
            console.log('field.field',field.field);
            if ( action == 'new' ) return this.newMessage();

            switch ( field.field ) {
                case 'created': return this.deleteMessage( item );

            }

            console.log({
                action,
                field,
                item,
                value
            });

        },
        'edit-member' ({ action, field, value, item }) {
            switch ( action ) {
                case 'exit':
                    this.component = '';
                    this.item = false;
                break;    
            }
        },
        emit ( data ) {
            if ( data.action == 'exit' ) {
                this.component = '';
                this.item = false
            }

            if ( typeof this[data.t] == 'function' ) return this[data.t](data);
            console.log('what emmit');
        },
        ...mapActions([
            'getCustomerName'
        ])
    }
}    
</script>

<style scopped>
.no-sms::before {
    margin-top: 2px;
}
</style>